import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import LayoutRoutes from './LayoutRoutes';
import PrivateRoutes from './PrivateRoutes';
import SignIn from '../Auth';

export default function Routers() {
  const login = localStorage.getItem("isLoggedIn") === "true";

  return (
    <BrowserRouter basename="/">
      <Routes>
        {/* Public Route for Login */}
        <Route path="/login" element={<SignIn />} />

        {/* Protected Routes */}
        <Route path="/*" element={<PrivateRoutes />}>
          <Route path="*" element={<LayoutRoutes />} />
        </Route>

        {/* Default Redirect */}
        <Route path="/" element={<Navigate to={login ? "/firstLoader" : "/login"} />} />
      </Routes>
    </BrowserRouter>
  );
}
